import { SideBar } from "../../components/SideBar/SideBar";
import BillingAddress from "../../components/Modal/BillingAddress/BillingAddress";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import AddCard from "../../components/Stripe/AddCard/AddCard";
import {
  GetPaymentMethod,
  RemovePaymentMethod,
} from "../../services/payment.service";
import useAuthService from "../../auth/AuthService";
import { handleMessage } from "../../utils/handleMessagePopup";
import { IBillingResponse, IPaymentMethodsResponse } from "../../types/types";
import {
  GetBillingAddress,
} from "../../services/billingDetails.service";
import { getCardLogo } from "../../utils/cardLogoUtility";
// import { CreateStripeConnectAccount, GetStripeConnectAccountDetails } from "../../services/stripeConnect.service";
 
interface PayoutState {
  showBillingModal: boolean;
  addCard: boolean;
  updateCard: boolean;
  isLoading: boolean;
}
 
interface PayoutMethodProps {
  userRole: string;
}
 
const PayoutMethod: React.FC<PayoutMethodProps> = ({ userRole }) => {
  const { getToken } = useAuthService();
  const [data, setdata] = useState<IPaymentMethodsResponse[]>();
 
  const [state, setState] = useState({
    showBillingModal: false,
    addCard: false,
    updateCard: false,
    isLoading: false,
    idDefault: false,
    billingDetails: {} as IBillingResponse,
 
    stripeConnectData: {
      stripe_connect_id: "",
      is_charges_enabled: false,
      is_payouts_enabled: false,
    },
  });
 
  // useEffect(() => {
  //   const fetchData = async () => {
  //     toggleModal("isLoading");
  //     if (isAuthenticated) {
  //       try {
  //         const res: any = await GetStripeConnectAccountDetails(getToken);
  //         if (res.data != null && res.error === null) {
  //           setState((prev) => ({ ...prev, stripeConnectData: res.data }));
  //         }
  //       } catch (error) {
  //         console.error("Failed to fetch Stripe Connect data:", error);
  //       }
  //     }
  //     toggleModal("isLoading");
  //   };
 
  //   fetchData();
  //   // eslint-disable-next-line
  // }, []);
 
  useEffect(() => {
    const fetchData = async () => {
      if (!state.addCard || !state.showBillingModal) {
        toggleModal("isLoading");
        const billingResponse: any = await GetBillingAddress(getToken);
        if (billingResponse.data?.status_code === 200) {
          setState((prev) => ({
            ...prev,
            billingDetails: billingResponse.data.data,
          }));
        } else {
          setState((prev) => ({
            ...prev,
            billingDetails: billingResponse.data,
          }));
        }
        const res: any = await GetPaymentMethod(getToken);
        if (res.data.status_code === 200 && res.data.data !== null) {
          setdata(res.data.data);
        } else {
          setdata([]);
        }
 
        toggleModal("isLoading");
      }
    };
    fetchData();
  }, [state.addCard, state.showBillingModal, getToken]);
 
  const toggleModal = (key: keyof PayoutState) => {
    setState((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };
 
  const handleRemoveCard = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      showCloseButton: true,
      showCancelButton: true,
      reverseButtons: true,
      showConfirmButton: true,
      width: 500,
      confirmButtonText: "Yes, Remove Card",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "removeCard",
        confirmButton: "confirm-btn alert-btn",
        cancelButton: "cancel-btn alert-btn",
      },
      color: "#ffffff",
      timer: 100000,
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleModal("isLoading");
        const res: any = await RemovePaymentMethod(
          {
            payment_method_id: id,
          },
          getToken
        );
        if (res.data?.status_code === 200) {
          setdata((pre) =>
            pre?.filter((data) => data.payment_method_id !== id)
          );
          handleMessage("Payment Method Successfully Removed");
        }
        else {
          handleMessage("❌ Error in Removing Payment Method");
        }
        toggleModal("isLoading");
      }
    });
  };
 
  // const handleCreateStripeConnectAccount = async () => {
  //   toggleModal("isLoading");
  //   try {
  //     const res = await CreateStripeConnectAccount(getToken);
 
  //     if (res?.data !== null && res.error === null) {
  //       window.location.href = res.data.onboarding_link;
  //     } else {
  //       console.error("No URL found in response");
  //     }
  //   } catch (error) {
  //     console.error("Error creating Stripe connect account:", error);
  //     toggleModal("isLoading");
  //   }
  // };
 
  return (
    <>
      <div className="container profile-page ps-2">
        <div className="edit-profile-header py-4">Settings</div>
        <div className="payment-details">
          <div className="side-bar">
            <SideBar ActiveItem="payoutMethods" userRole={userRole} />
          </div>
          <div className="page-content">
            <div className="row m-0 profile-content payment-content">
              <div className="col-md-6 p-0 m-0">
                <div className="d-flex justify-content-between">
                  <div className="heading">Payment Information</div>
                </div>
                <div className="d-flex my-4">
                  <div className="w-100">
                    <div className="sub-heading d-flex">
                      Billing Address
                      <div
                        className="icon ms-3 d-flex"
                        onClick={() => toggleModal("showBillingModal")}
                      >
                        <div className="font-inter-400-14">Edit</div>
                        <i className="fa-solid fa-pencil ps-2 my-auto"></i>
                      </div>
                    </div>
                    <div className="content text-white">
                      {!state.billingDetails ? (
                        "-"
                      ) : (
                        <>
                          {state.billingDetails.name} <br />
                          {state.billingDetails.address_line1}{" "}
                          {state.billingDetails.address_line2} <br />
                          {state.billingDetails.city && (
                            <>{state.billingDetails.city}, </>
                          )}
                          {state.billingDetails.state && (
                            <>{state.billingDetails.state}, </>
                          )}
                          {state.billingDetails.country}{" "}
                          {state.billingDetails.postal_code}
                        </>
                      )}
                      <br />
                    </div>
                  </div>
                </div>
                <div className="box-custom rounded-2 mt-3 mb-5 p-0">
                  <div className="row justify-content-between">
                    <div className="sub-heading">Payment Methods</div>
                  </div>
                  {state.isLoading ? (
                    <div className="loader">
                      <div className="spinner"></div>
                    </div>
                  ) : (
                    <div className="payment-method my-3">
                      {data?.map((res, index) => {
                        const isLastItem = index === data.length - 1;
                        const nextItemIsNotDefault =
                          data.at(index + 1)?.is_default === false;
                        return (
                          <div
                            key={res.payment_method_id}
                            className={`d-flex ${res.is_default
                              ? "pay-active"
                              : !isLastItem && nextItemIsNotDefault
                                ? "border-bottom-custom pay"
                                : "pay"
                              }
                    `}
                          >
                            <img
                              src={getCardLogo(res.brand)}
                              alt={res.brand}
                              className="pay-logo my-auto "
                            />
                            <div className="d-flex col justify-content-between">
                              <div className="col-5 my-auto">
                                <div className="ps-2 mb-1 heading">
                                  {res.brand.charAt(0).toUpperCase() + res.brand.slice(1)}
                                </div>
 
                                <p className="ps-2 mb-0 sub-heading">
                                  **** **** **** {res.last4}
                                </p>
                              </div>
                              <div className="my-auto">
                                {res.is_default && (
                                  <div className="default px-1">default</div>
                                )}
                                <div
                                  className="icon"
                                  onClick={() =>
                                    handleRemoveCard(res.payment_method_id)
                                  }
                                >
                                  <svg
                                    width="15"
                                    height="14"
                                    viewBox="0 0 15 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2 3H13M5 3V2C5 1.44772 5.44772 1 6 1H9C9.55228 1 10 1.44772 10 2V3M11 3V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V3H11Z"
                                      stroke="#CBC0EA"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div
                    className="btn btn-primary button my-1"
                    onClick={() => toggleModal("addCard")}
                  >
                    Add a Payment Method
                    <i className="fa-regular fa-credit-card ms-3"></i>
                  </div>
                </div>
              </div>
              {/*    {isAuthenticated && userRole === "moderator" && (
                <div className="col-md-6 p-0">
                  <div className="d-flex justify-content-between">
                    <div className="heading">Payout Information</div>
                  </div>
                  {state.stripeConnectData.stripe_connect_id === "" && (
                    <div
                      className="btn btn-primary button my-4 mt-3"
                      onClick={handleCreateStripeConnectAccount}
                    >
                      Set up payouts to your bank
                      <svg
                        className="ms-2"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.32227 0.962891L14.9727 4.6543C15.2949 4.83008 15.5 5.15234 15.5 5.50391C15.5 6.06055 15.0312 6.5 14.5039 6.5H1.49609C0.939453 6.5 0.5 6.06055 0.5 5.50391C0.5 5.15234 0.675781 4.83008 0.998047 4.6543L7.64844 0.962891C7.85352 0.845703 8.11719 0.845703 8.32227 0.962891ZM7.17969 5.09375C7.0918 4.97656 7.0625 4.80078 7.0625 4.625C7.0625 4.12695 7.47266 3.6875 8 3.6875C8.49805 3.6875 8.9375 4.12695 8.9375 4.625C8.9375 4.80078 8.87891 4.97656 8.79102 5.09375H12.8926L8 2.39844L3.07812 5.09375H7.17969ZM2.375 7.4375H3.78125V12.125H5.65625V7.4375H7.0625V12.125H8.9375V7.4375H10.3438V12.125H12.2188V7.4375H13.625V12.125H13.8594C14.2402 12.125 14.5625 12.4473 14.5625 12.8281C14.5625 13.2383 14.2402 13.5312 13.8594 13.5312H2.375C1.96484 13.5312 1.67188 13.2383 1.67188 12.8281C1.67188 12.4473 1.96484 12.125 2.375 12.125V7.4375ZM1.4375 14.4688H14.7969C15.1777 14.4688 15.5 14.791 15.5 15.1719C15.5 15.582 15.1777 15.875 14.7969 15.875H1.4375C1.02734 15.875 0.734375 15.582 0.734375 15.1719C0.734375 14.791 1.02734 14.4688 1.4375 14.4688Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  )}
 
                  {state.stripeConnectData.stripe_connect_id !== "" &&
                    !state.stripeConnectData.is_charges_enabled &&
                    !state.stripeConnectData.is_payouts_enabled && (
                      <div className="my-4">
                        <p className="d-flex align-items-center">
                          <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.17188 6.84375C2.9375 7.3125 2.39062 7.50781 1.92188 7.3125C1.45312 7.11719 1.21875 6.57031 1.41406 6.10156C2.74219 2.97656 5.86719 0.75 9.5 0.75C11.5312 0.75 13.4844 1.57031 14.9297 3.01562L17 5.08594V2.9375C17 2.42969 17.3906 2 17.9375 2C18.4453 2 18.875 2.42969 18.875 2.9375V7.3125C18.875 7.85938 18.4453 8.25 17.9375 8.25H13.5625C13.0156 8.25 12.625 7.85938 12.625 7.3125C12.625 6.80469 13.0156 6.375 13.5625 6.375H15.6719L13.6016 4.34375C12.5078 3.25 11.0234 2.625 9.5 2.625C6.64844 2.625 4.1875 4.38281 3.17188 6.84375ZM17.5469 12.9766C16.1797 16.0625 13.0938 18.25 9.5 18.25C7.42969 18.25 5.47656 17.4688 4.03125 15.9844L2 13.9531V16.0625C2 16.6094 1.57031 17 1.0625 17C0.515625 17 0.125 16.6094 0.125 16.0625V11.6875C0.125 11.1797 0.515625 10.75 1.0625 10.75H5.4375C5.94531 10.75 6.375 11.1797 6.375 11.6875C6.375 12.2344 5.94531 12.625 5.4375 12.625H3.28906L5.35938 14.6953C6.45312 15.7891 7.9375 16.375 9.5 16.375C12.3125 16.375 14.7734 14.6953 15.7891 12.2344C16.0234 11.7266 16.5703 11.5312 17.0391 11.7266C17.5078 11.9219 17.7422 12.4688 17.5469 12.9766Z"
                              fill="#FFBE33"
                            />
                          </svg>
                          <span className="ms-2 font-500-20">
                            Payout setup in progress.
                          </span>
                        </p>
                        <p className="font-inter-300-15">
                          Please check your email or
                          <span
                            className="text-light-purple cursor-pointer"
                            onClick={handleCreateStripeConnectAccount}
                          >
                            {" "}
                            click here{" "}
                          </span>
                          to continue.
                        </p>
                      </div>
                    )}
                  {state.stripeConnectData.stripe_connect_id !== "" &&
                    state.stripeConnectData.is_charges_enabled &&
                    state.stripeConnectData.is_payouts_enabled && (
                      <div className="my-4">
                        <p className="font-500-20">Account Status</p>
                        <p className="font-inter-300-15 d-flex align-items-center">
                          <i className="fa-solid fa-square-check text-orange me-2"></i>
                          <span className="font-inter-300-15">
                            Your account is ready to receive payouts.
                          </span>
                        </p>
                        <div
                          className="btn btn-primary button my-4 mt-3"
                          onClick={handleCreateStripeConnectAccount}
                        >
                          Update Payout Info on
                          <svg
                            className="ms-2"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.32227 0.962891L14.9727 4.6543C15.2949 4.83008 15.5 5.15234 15.5 5.50391C15.5 6.06055 15.0312 6.5 14.5039 6.5H1.49609C0.939453 6.5 0.5 6.06055 0.5 5.50391C0.5 5.15234 0.675781 4.83008 0.998047 4.6543L7.64844 0.962891C7.85352 0.845703 8.11719 0.845703 8.32227 0.962891ZM7.17969 5.09375C7.0918 4.97656 7.0625 4.80078 7.0625 4.625C7.0625 4.12695 7.47266 3.6875 8 3.6875C8.49805 3.6875 8.9375 4.12695 8.9375 4.625C8.9375 4.80078 8.87891 4.97656 8.79102 5.09375H12.8926L8 2.39844L3.07812 5.09375H7.17969ZM2.375 7.4375H3.78125V12.125H5.65625V7.4375H7.0625V12.125H8.9375V7.4375H10.3438V12.125H12.2188V7.4375H13.625V12.125H13.8594C14.2402 12.125 14.5625 12.4473 14.5625 12.8281C14.5625 13.2383 14.2402 13.5312 13.8594 13.5312H2.375C1.96484 13.5312 1.67188 13.2383 1.67188 12.8281C1.67188 12.4473 1.96484 12.125 2.375 12.125V7.4375ZM1.4375 14.4688H14.7969C15.1777 14.4688 15.5 14.791 15.5 15.1719C15.5 15.582 15.1777 15.875 14.7969 15.875H1.4375C1.02734 15.875 0.734375 15.582 0.734375 15.1719C0.734375 14.791 1.02734 14.4688 1.4375 14.4688Z"
                              fill="black"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                </div>
              )}*/}
            </div>
          </div>
        </div>
      </div>
 
      {/* Add Card */}
      {state.addCard && (
        <AddCard
          title="Add Card"
          id="AddCardModal"
          isDefault={data?.length === 0}
          billing_Details={state.billingDetails}
          onClick={() => {
            toggleModal("addCard");
            handleMessage("Payment Method Successfully Added");
          }}
          onClose={() => toggleModal("addCard")}
          isVisible={state.addCard}
        />
      )}
 
      {/* Billing Details */}
      {state.showBillingModal && (
        <BillingAddress
          data={state.billingDetails}
          isVisible={state.showBillingModal}
          onClick={() => {
            toggleModal("showBillingModal");
            handleMessage("Billing Address Successfully Updated");
          }}
          onClose={() => toggleModal("showBillingModal")}
        />
      )}
    </>
  );
};
 
export default PayoutMethod;
 
 